import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";

import "slick-carousel/slick/slick-theme.css";

import { fetchPublicSponsors } from "../../features/admin/SponsorSlice";

const getMediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${process.env.REACT_APP_API_URL}media/${url}`;
};

const getFallbackLogo = (name) => {
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(
    name || "Nhà tài trợ",
  )}&size=200&background=random&color=fff&bold=true`;
};

const SponsorLogoSlider = () => {
  const dispatch = useDispatch();
  const [canAutoPlay, setCanAutoPlay] = useState(false);

  const { publicSponsors, publicStatus } = useSelector(
    (state) => state.sponsors,
  );

  useEffect(() => {
    if (publicStatus === "idle") {
      dispatch(fetchPublicSponsors());
    }
  }, [dispatch, publicStatus]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCanAutoPlay(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const sponsors = (publicSponsors || [])
    .filter((sponsor) => sponsor?.status !== false)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: canAutoPlay,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (publicStatus === "loading") {
    return (
      <div className="container mx-auto">
        <div className="card bg-base-100 shadow-xl">
          <div className="card-body py-10 text-center text-gray-500">
            Đang tải nhà tài trợ...
          </div>
        </div>
      </div>
    );
  }

  if (!sponsors.length) {
    return null;
  }

  return (
    <div className="container mx-auto ">
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <Slider
            key={canAutoPlay ? "sponsor-slider-play" : "sponsor-slider-wait"}
            {...settings}
            className="partner-slider"
          >
            {sponsors.map((sponsor) => (
              <div key={sponsor.id} className="px-2">
                <Link to={`/nha-tai-tro/${sponsor.id}`}>
                  <div className="flex shadow-md rounded-lg p-2 gap-4 my-2 bg-base-100 hover:bg-gray-200">
                    <div className="w-full flex justify-center">
                      {sponsor?.logo ? (
                        <img
                          src={getMediaUrl(sponsor.logo)}
                          alt={sponsor.name}
                          className="rounded-md object-contain w-40 h-40"
                          style={{ aspectRatio: 1 / 1 }}
                          loading="lazy"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = getFallbackLogo(sponsor.name);
                          }}
                        />
                      ) : (
                        <img
                          src={getFallbackLogo(sponsor.name)}
                          alt="Logo nhà tài trợ"
                          className="rounded-md object-contain w-40 h-40"
                          loading="eager"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = getFallbackLogo(sponsor.name);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <style jsx>{`
        .vertical-partner-slider .slick-prev,
        .vertical-partner-slider .slick-next {
          left: 50%;
          transform: translateX(-50%);
        }

        .vertical-partner-slider .slick-prev {
          top: -20px;
        }

        .vertical-partner-slider .slick-next {
          top: auto;
          bottom: -20px;
        }

        .vertical-partner-slider .slick-prev:before,
        .vertical-partner-slider .slick-next:before {
          color: #666;
        }

        .vertical-partner-slider .slick-dots {
          right: -20px;
          left: auto;
          top: 50%;
          transform: translateY(-50%);
          width: auto;
          height: auto;
          display: flex !important;
          flex-direction: column;
        }

        .vertical-partner-slider .slick-dots li {
          margin: 5px 0;
        }

        .vertical-partner-slider .slick-track {
          display: flex;
          flex-direction: column;
        }
      `}</style>
    </div>
  );
};

export default SponsorLogoSlider;
